type KeyValuePairs = { [key: string]: any };

const runFlattenObject = (
    object: KeyValuePairs,
    delimiter: string,
    keys: string[],
): KeyValuePairs => {
    if (!object) {
        return {};
    }

    return Object.keys(object).reduce((acc, key) => {
        const value = object[key];
        const currKeys = [...keys, key];

        if (typeof value === 'object' && !Array.isArray(value)) {
            return { ...acc, ...runFlattenObject(value, delimiter, currKeys) };
        }

        if (typeof value === 'object' && Array.isArray(value)) {
            return {
                ...acc,
                ...runFlattenObject(value.flat(), delimiter, currKeys),
            };
        }

        return { ...acc, [currKeys.join(delimiter)]: value };
    }, {});
};

/**
 * Flattens object to be 1 level deep.
 * @param {object} object
 * @param {string} delimiter - key delimiter, '.' by default
 * @return flattened object
 */
export const flattenObject = (object: KeyValuePairs, delimiter = '.'): KeyValuePairs => {
    return runFlattenObject(object, delimiter, []);
};
